import { reactive } from 'vue';
import api from './api';

const STORAGE_KEY = 'mhlm.session';

function readStored() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
  catch { return null; }
}

const initial = readStored();

export const auth = reactive({
  user:  initial?.user  || null,
  token: initial?.token || null,
  get isLoggedIn() { return !!this.token; }
});

function persist() {
  if (auth.token) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ user: auth.user, token: auth.token }));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export async function login(credentials) {
  const { data } = await api.post('/login', credentials);
  if (data.requires_2fa) {
    // El llamante (LoginView) maneja el flujo 2FA; no persistimos sesión aún
    return data;
  }
  auth.user  = data.user;
  auth.token = data.token;
  persist();
  return data;
}

export async function loginTwoFactor({ ticket, code }) {
  const { data } = await api.post('/login/2fa', { ticket, code });
  auth.user  = data.user;
  auth.token = data.token;
  persist();
  return data;
}

export async function register(payload) {
  const { data } = await api.post('/register', payload);
  auth.user  = data.user;
  auth.token = data.token;
  persist();
  return data;
}

export async function logout() {
  try { await api.post('/logout'); } catch { /* ignore */ }
  clearSession();
}

export function clearSession() {
  auth.user  = null;
  auth.token = null;
  persist();
}

export async function fetchMe() {
  const { data } = await api.get('/me');
  auth.user = data;
  persist();
  return data;
}

export function setSessionFromToken(token) {
  auth.token = token;
  auth.user  = auth.user || { email: '' };
  persist();
}

// Auto-logout si el interceptor detecta 401
if (typeof window !== 'undefined') {
  window.addEventListener('mhlm:auth-401', () => clearSession());
}

// Flag global para que las vistas puedan detectar si estamos navegando por 401 y no mostrar error ruidoso
export const authState = { silentLogout: false };
